








































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { UpdateUserIdentityRequestModel } from '@/modules/user/models/user-request.model'
import { Prop } from 'vue-property-decorator'
import { UserResourceInAdminModel } from '@/modules/user/models/user-resource.model'
import StatusIcon from '@/modules/shared/components/shared/icon/StatusIcon.vue'
import { AdminUpdateUserInfoUseCase } from '@/modules/user/use-cases/admin/admin-update-user-info.use-case'

@Component({
  components: {
    StatusIcon,
    BaseButton,
    BaseInput
  }
})
export default class AdminUserIdentityForm extends Vue {
  constructor(
    private readonly useCase: AdminUpdateUserInfoUseCase
  ) {
    super()
  }

  @Prop({ required: true }) userResource: UserResourceInAdminModel

  private usernameDisable: boolean = true

  protected displayname = this.userResource.displayname

  protected email = this.userResource.email

  protected phone = this.userResource.phone

  protected username = this.userResource.username

  private get usernameButtonToggleColor() {
    return !this.usernameDisable ? 'tes-blue' : 'tes-grey-dark'
  }

  protected onSubmit() {
    const requestData: UpdateUserIdentityRequestModel = {
      displayname: this.displayname,
      email: this.email,
      phone: this.phone,
      username: this.username
    }

    this.useCase.execute(this.userResource.id, requestData)
  }
}
